import React, { useContext } from 'react'
import { ReducerDispatchContext, ReducerContext } from '../reducers/reducerContext.js';
import { setFinParameters, openWidget, setWidgetParameters, setCustomer, reloadWidgetSFS } from '../actions/actionsAppTest';
import { fetchSimulationVehicleDetailsIfNeeded, fetchSimulationVehiclesIfNeeded, fetchSimulationOptionsIfNeeded,
  fetchSimulationAccessoriesIfNeeded } from '../actions/actionsApiSimulation';
import ResultSummary from '../components/results/ResultSummary'

export default function ContResultSummary() {
  const dispatch = useContext(ReducerDispatchContext);
  const globalstate = useContext(ReducerContext);

  function onChangeParameters(value, widgetParameters, customer) {
    fetchSimulationVehicleDetailsIfNeeded(globalstate, dispatch, {parameters:value}, customer, false, false);
    fetchSimulationOptionsIfNeeded(globalstate, dispatch, {parameters:value}, null, customer, false);
    fetchSimulationAccessoriesIfNeeded(globalstate, dispatch, {parameters:value}, null, customer, false);
    fetchSimulationVehiclesIfNeeded(globalstate, dispatch, {parameters:value}, null, null, customer, false);
    dispatch(setFinParameters(value));
    dispatch(setWidgetParameters(widgetParameters));
    if (customer != null) {
      dispatch(setCustomer(customer));
    }
  }
  function onOpenWidget(isOpen) {
    dispatch(openWidget(isOpen));
  }
  function onReloadWidgetSFS(){
    dispatch(reloadWidgetSFS());
  }

  return (
    <ResultSummary
      settings={globalstate.settings}
      widgetState={globalstate.widget}
      context={globalstate.testCriteria.context}
      partExchange={globalstate.testCriteria.partExchange}
      parameters={globalstate.testCriteria.parameters}
      parametersForFetch={globalstate.testCriteria.parametersForFetch}
      widgetParameters={globalstate.testCriteria.widgetParameters}
      vehicle={globalstate.testCriteria.vehicle}
      responseSimulation={globalstate.responseSimulation}
      env={globalstate.env}
      openState={globalstate.openState}
      onChangeParameters={onChangeParameters}
      onOpenWidget={onOpenWidget}
      onReloadWidget={onReloadWidgetSFS}
    />
  );
}
